import { useEffect, useRef, useState } from "react";
import { Loader2, SendHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

const when = (iso) => new Date(iso).toLocaleString("es-CL", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "America/Santiago" });

export function ChatThread({ messages, mine, otherLabel, onSend, empty, testId = "chat" }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [messages?.length]);
  const send = async () => {
    if (!text.trim() || busy) return;
    setBusy(true);
    try { await onSend(text.trim()); setText(""); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col h-full min-h-0" data-testid={testId}>
      <div className="flex-1 min-h-0 overflow-y-auto space-y-3 p-4 bg-muted/30" data-testid={`${testId}-messages`}>
        {messages === null && <div className="grid place-items-center py-10"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>}
        {messages?.length === 0 && <p className="text-sm text-center text-muted-foreground py-10" data-testid={`${testId}-empty`}>{empty}</p>}
        {messages?.map((m) => {
          const me = m.sender === mine;
          return (
            <div key={m.id} className={`flex ${me ? "justify-end" : "justify-start"}`} data-testid={`${testId}-msg-${m.id}`}>
              <div className={`max-w-[80%] rounded-2xl px-3.5 py-2 text-sm shadow-sm ${me ? "bg-primary text-primary-foreground rounded-br-md" : "bg-background border rounded-bl-md"}`}>
                {!me && <p className="text-[11px] font-semibold text-primary mb-0.5">{otherLabel}</p>}
                <p className="whitespace-pre-wrap break-words">{m.text}</p>
                <p className={`text-[10px] mt-1 text-right ${me ? "text-primary-foreground/70" : "text-muted-foreground"}`}>{when(m.created_at)}</p>
              </div>
            </div>
          );
        })}
        <div ref={end} />
      </div>
      <div className="border-t p-3 flex items-end gap-2 bg-background">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={2000} placeholder="Escribe un mensaje…"
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
          className="resize-none min-h-[44px]" data-testid={`${testId}-input`} />
        <Button onClick={send} disabled={busy || !text.trim()} size="icon" className="h-11 w-11 shrink-0 rounded-full" aria-label="Enviar" data-testid={`${testId}-send`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <SendHorizontal className="w-4 h-4" />}
        </Button>
      </div>
    </div>
  );
}
